import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  // faLock,
  // faSignOutAlt,
  // faUser,
} from "@fortawesome/free-solid-svg-icons";
import {
  Navbar,
  // Button,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  // NavLink,
  // Dropdown,
  // DropdownToggle,
  // DropdownMenu,
  // DropdownItem,
} from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";

import LocalStorageService from "../utils/localStorageServices";
// import SOURCES from "../utils/constants";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import Notifications from "./notifications";
import { Button, Dropdown } from "antd";
import {
  LogoutOutlined,
  UserOutlined,
  // LockOutlined
} from "@ant-design/icons";
// import { Avatar, Space } from "antd";
import { getTitle } from "../utils/helper";
const localStorageServices = LocalStorageService.getService();

const Topbar = ({ toggleSidebar }) => {
  // const currentUser = localStorageServices.getCurrentUser();
  // const userType = currentUser.user?.userType;
  const [topbarIsOpen, setTopbarOpen] = useState(false);
  const toggleTopbar = () => setTopbarOpen(!topbarIsOpen);
  const [toggle, setToggle] = useState(false);
  const loggedUser = localStorageServices.getCurrentUser().user;
  const logOut = () => {
    localStorageServices.clearToken();
    window.location.reload();
  };
  const history = useHistory();
  const location = useLocation();

  return (
    <Navbar
      className="navbar  sticky top-0 z-50 relative !p-0"
      expand="md"
    >
      {/* Blur layer */}
      {/* <div className="absolute -top-10 left-0 w-full h-20 bg-secondary/5 backdrop-blur-[2px] z-0" /> */}

      {/* Content */}
      <div className="relative z-10 flex justify-between items-center w-full bg-white py-3 px-6 rounded-none mb-3">

        <Button color="primary" onClick={toggleSidebar} className="hover:!border-primary hover:!text-primary">
          <FontAwesomeIcon icon={faBars} size="sm" />
        </Button>
        <NavbarToggler
          onClick={toggleTopbar}
          style={{ fontSize: "1rem", padding: "5px 6px" }}
        />

        <h1 className="text-2xl font-semibold ml-2">
          {getTitle(location.pathname)}
        </h1>
        <Collapse isOpen={topbarIsOpen} navbar>
          <Nav
            className="ml-auto mt-2 flex items-center justify-end w-full gap-4"
            navbar
          >
            <NavItem>
              <Notifications />
              {/* <div class="dropdown relative inline-flex">
              <button
                id="dropdown-default"
                type="button"
                class="dropdown-toggle btn btn-primary"
                aria-haspopup="menu"
                aria-expanded="false"
                aria-label="Dropdown"
              >
                Dropdown
                <span class="icon-[tabler--chevron-down] dropdown-open:rotate-180 size-4"></span>
              </button>
              <ul
                class="dropdown-menu dropdown-open:opacity-100 hidden min-w-60"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="dropdown-default"
              >
                <li>
                  <a class="dropdown-item" href="#">
                    My Profile
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    Settings
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    Billing
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    FAQs
                  </a>
                </li>
              </ul>
            </div> */}
            </NavItem>
            <NavItem>
              {/* <Dropdown isOpen={toggle} toggle={() => setToggle(!toggle)}>
              <DropdownToggle className="nav-user" caret>
                {loggedUser.name}
              </DropdownToggle>
              <DropdownMenu end>
                {userType !== SOURCES.USER_ROLE_AFFILIATE && (
                  <>
                    <DropdownItem header>
                      <NavLink tag={Link} to={"/profile"}>
                        <FontAwesomeIcon icon={faUser} className="mr-2" />
                        Profile
                      </NavLink>
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem header>
                      <NavLink tag={Link} to={"/changepassword"}>
                        <FontAwesomeIcon icon={faLock} className="mr-2" />
                        Change Password
                      </NavLink>
                    </DropdownItem>
                    <DropdownItem divider />
                  </>
                )}
                <DropdownItem color="info" onClick={logOut}>
                  <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
                  Sign Out
                </DropdownItem>
              </DropdownMenu>
            </Dropdown> */}

              <Dropdown
                onOpenChange={(next) => setToggle(next)}
                popupRender={() => (
                  <div className="bg-white min-w-[270px] min-h-fit rounded-md shadow-lg flex flex-col overflow-hidden">
                    {/* HEADER */}
                    <div className="px-3 py-2 border-b border-secondary/15 sticky top-0 bg-white z-10">
                      <li class="gap-3 flex items-center">
                        <div class="!size-10 rounded-full !bg-primary overflow-hidden flex justify-center items-center">
                          <p className="text-lg capitalize  text-white font-medium !leading-none !tracking-wide">
                            {loggedUser.name
                              .split(" ")
                              .slice(0, 2)
                              .map((name) => name.charAt(0))
                              .join("")}
                          </p>
                        </div>
                        <div>
                          <h6 class="text-base-content text-base font-semibold">
                            {loggedUser.name}
                          </h6>
                          <p class="w-full text-sm font-normal line-clamp-1">
                            {loggedUser.email}
                          </p>
                        </div>
                      </li>
                    </div>

                    {/* content */}
                    <div className="px-3 py-2 flex flex-col space-y-2">
                      <Button
                        className="!flex items-center justify-start border-none relative px-3 py-2 text-gray-900 rounded-lg hover:!bg-gray-100 hover:!text-primary text-base font-medium gap-2"
                        icon={<UserOutlined />}
                        onClick={() => history.push("/profile")}
                      >
                        Profile
                      </Button>
                      {/* <Button
                        className="!flex items-center justify-start border-none relative px-3 py-2 text-gray-900 rounded-lg hover:!bg-gray-100 hover:!text-primary text-base font-medium gap-2 "
                        icon={<LockOutlined />}
                        onClick={() => history.push("/changepassword")}
                      >
                        Change Password
                      </Button> */}
                    </div>
                    {/* FOOTER */}
                    <div className="px-3 py-2 border-t border-secondary/15 sticky bottom-0 bg-white z-10 flex justify-center">
                      <Button
                        className="!bg-primary text-white w-full hover:!bg-primary hover:!border-primary text-sm font-medium h-9"
                        icon={<LogoutOutlined />}
                        onClick={logOut}
                      >
                        Sign out
                      </Button>
                    </div>
                  </div>
                )}
                trigger={["click"]}
              >
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  id="dropdown-avatar"
                  type="button"
                  className="border !border-primary hover:!text-primary flex items-center gap-2 rounded-full px-2 h-10"
                // aria-label="Dropdown"
                >
                  <div class="size-8 rounded-full overflow-hidden !bg-primary flex justify-center items-center">
                    <p className="text-sm capitalize text-white font-medium !leading-none !tracking-wide">
                      {loggedUser.name
                        .split(" ")
                        .slice(0, 2)
                        .map((name) => name.charAt(0))
                        .join("")}
                    </p>
                  </div>
                  <div className="space-x-1 flex items-center ">
                    <span>{loggedUser.name}</span>
                    {toggle ? (
                      <FaAngleUp style={{ fontSize: 18 }} className="mt-0.5" />
                    ) : (
                      <FaAngleDown style={{ fontSize: 18 }} className="mt-0.5" />
                    )}
                  </div>
                </Button>
              </Dropdown>
            </NavItem>
          </Nav>
        </Collapse>
      </div>
    </Navbar>
  );
};

export default Topbar;
